export function extractCustomCohortsFromQueryParams(urlStr, customQueryCohorts) {
    if (!customQueryCohorts) {
        return undefined;
    }
    const url = new URL(urlStr);
    const rec = {};
    for (const [key, val] of url.searchParams) {
        if (customQueryCohorts.includes(key)) {
            rec[key] = val;
        }
    }
    return Object.keys(rec).length > 0 ? rec : undefined;
}
